// Please move this to become a higher level service if it's used in another component

function randomInt(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

export { randomInt };
